import { useMemo } from 'react';

import type { CycleInstance } from '@/types/cycle-evaluation/CycleInstance';

import { ReviewInstanceStatus } from '@/constants/review/ReviewInstanceStatus';

interface UseAssessmentReadOnlyResult {
    isCompleted: boolean;
    isReadOnly: boolean;
    canEdit: boolean;
    canUndo: boolean;
}

export const useAssessmentReadOnly = (
    cycleInstance?: CycleInstance | null,
): UseAssessmentReadOnlyResult => {
    return useMemo(() => {
        const isCompleted =
            cycleInstance?.reviewInstances?.some(
                (reviewInstance) => reviewInstance.status === ReviewInstanceStatus.COMPLETED,
            ) ?? false;

        return {
            isCompleted,
            isReadOnly: isCompleted,
            canEdit: !isCompleted,
            canUndo: isCompleted,
        };
    }, [cycleInstance]);
};
